module.exports = __webpack_public_path__ + "img/example.2d66d594.png";